import { hasMasterSession } from "./authSession";

/**
 * Home path for an authenticated session visiting guest routes (/, /login).
 * New accounts without a business go to onboarding; everyone else to dashboard.
 */
export function getPostAuthPath(loginToken, loginTokenCoUser) {
  // Co-users / agents do not create a business via onboarding.
  if (loginTokenCoUser?.response?.token) {
    return "/dashboard";
  }

  if (!hasMasterSession(loginToken)) {
    return null;
  }

  const user = loginToken.response.user;
  const hasBusiness = Boolean(
    user?.business_id ||
      user?.master_business?.id ||
      user?.master_business?._id,
  );

  return hasBusiness ? "/dashboard" : "/on-boarding";
}

export function isAuthenticatedSession(loginToken, loginTokenCoUser) {
  return Boolean(
    hasMasterSession(loginToken) || loginTokenCoUser?.response?.token,
  );
}
